export const REDACT_TOOL_ID = "redact";

const drawRedactRect = ({ ctx, from, to }) => {
  const left = Math.min(from.x, to.x);
  const top = Math.min(from.y, to.y);
  const width = Math.abs(to.x - from.x);
  const height = Math.abs(to.y - from.y);

  if (width < 2 || height < 2) {
    return;
  }

  ctx.save();
  ctx.fillStyle = "rgba(0, 0, 0, 0.92)";
  ctx.fillRect(left, top, width, height);
  ctx.restore();
};

export const redactToolConfig = {
  id: REDACT_TOOL_ID,
  usesPreview: true,
  cursor: "crosshair",
  onStart: () => true,
  onMove: ({ ctx, lastPointRef, nextPoint }) => {
    drawRedactRect({
      ctx,
      from: lastPointRef.current,
      to: nextPoint,
    });
  },
  onEnd: ({ ctx, lastPointRef, endPoint }) => {
    drawRedactRect({
      ctx,
      from: lastPointRef.current,
      to: endPoint,
    });
  },
};

const RedactToolButton = ({ activeTool, onSelectTool }) => {
  return (
    <button
      type="button"
      className={`btn ${
        activeTool === REDACT_TOOL_ID ? "btn-dark" : "btn-outline-dark"
      }`}
      onClick={() => onSelectTool(REDACT_TOOL_ID)}
      title="Redact"
      aria-label="Redact"
    >
      █
    </button>
  );
};

export default RedactToolButton;
